// extracted by mini-css-extract-plugin
export default {"tableWrapper":"pure-table_tableWrapper__n2OLL"};